import { useDispatch, useSelector } from "react-redux";

import { useEffect } from "react";
import { useHistory, useParams } from "react-router-dom";
import FeatureChoices from "../components/FeatureChoices";
import FeatureChoicesPhone from "../components/FeatureChoicesPhone";
import MemberForm from "../components/MemberForm";
import Order from "../components/Order";
import SeniorDetail from "../components/SeniorDetail";
import StepsHeader from "../components/StepsHeader";
import Tab from "../components/Tab";
import UserForm from "../components/UserForm";
import { getLocaleFromPath, getRouteKeyFromSlug, localePath } from "../i18n/config";
import { AppState } from "../redux/types";

const UserPage = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const user = useSelector((state: AppState) => state.user);
    const isPhoneUser = user.chosenService === "phone";
    // console.log(user)
    useEffect(() => {
        if (!user?.id) {
            history.push(localePath("kirjaudu"));
        }
        return () => {};
    }, [dispatch, history, user]);

    //const { orders } = user
    //const paid = orders?.map((order: any) => order.isPaid)

    const { tab_id } = useParams<{ tab_id: string }>();

    // Map translated tab_id back to Finnish eventKey
    const tabKey = getRouteKeyFromSlug(tab_id, getLocaleFromPath(""))
        || getRouteKeyFromSlug(tab_id, "fi")
        || getRouteKeyFromSlug(tab_id, "en")
        || getRouteKeyFromSlug(tab_id, "sv")
        || tab_id;
    // console.log(tab_id)

    const onSelect = (k: any) => {
        history.push(localePath("tili", k));
    };

    return (
        <div className="user-page">
            {/* <SubNavBar /> */}
            {tabKey && user && user.group && !user.group.members ? (
                <>
                    <StepsHeader step1 step2 step3 step4 step5 />
                    <Tab
                        key1={tabKey}
                        onSelect={onSelect}
                        orders={<Order onSelect={onSelect} />}
                        userForm={<UserForm onSelect={onSelect} />}
                        memberForm={<MemberForm onSelect={onSelect} />}
                        seniorDetail={<SeniorDetail onSelect={onSelect} />}
                        featureChoices={!isPhoneUser ? <FeatureChoices onSelect={onSelect} key={tabKey} /> : <FeatureChoicesPhone onSelect={onSelect} key={tabKey} />}
                    />
                </>
            ) : (
                <Tab
                    key1={tabKey}
                    onSelect={onSelect}
                    orders={<Order onSelect={onSelect} />}
                    userForm={<UserForm onSelect={onSelect} />}
                    memberForm={<MemberForm onSelect={onSelect} />}
                    seniorDetail={<SeniorDetail onSelect={onSelect} />}
                    featureChoices={!isPhoneUser ? <FeatureChoices onSelect={onSelect} key={tabKey} /> : <FeatureChoicesPhone onSelect={onSelect} key={tabKey} />}
                />
            )}
        </div>
    );
};

export default UserPage;
